import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/src/app/components/DiscountPage/index.tsx");
